export default __webpack_public_path__ + "static/media/AllocateTutorial.a35df9b1.jpeg";